import { demoStoreActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

export function demoCases(builder: ActionReducerMapBuilder<NotificationState>) {
  builder
    .addCase(demoStoreActions.resetDemo.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'demoResetSuccess',
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(demoStoreActions.resetDemo.rejected, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'demoResetFailure',
        icon: 'warn',
        id: generateId(),
      })
    })
}
